import { AxiosResponse } from 'axios'
import axios from '@/services/axios'

export default abstract class FilesApi {
  public static route = process.env.VUE_APP_FILE_UPLOAD_V2_BASE_URI

  public static async upload(
    arenaId: string,
    file: Blob,
  ): Promise<AxiosResponse> {
    const data = new FormData()
    data.append('file', file)
    const url = `${this.route}/arenas/${arenaId}/shop/documents/upload`
    return await axios.post(url, data, {
      headers: { 'content-type': 'multipart/form-data;' },
    })
  }

  public static async download(
    arenaId: string,
    file_name: string,
  ): Promise<AxiosResponse> {
    const url = `${this.route}/arenas/${arenaId}/shop/documents/presign-download`
    const data = { file_name }
    return await axios.post(url, data)
  }

  public static async downloadInvoice(
    arenaId: string,
    file_name: string,
  ): Promise<AxiosResponse> {
    const url = `${this.route}/arenas/${arenaId}/shop/invoices/presign-download`
    const data = { file_name }
    return await axios.post(url, data)
  }
}
